import React from 'react'
import ReactDOM from 'react-dom/client'
// import './index.css'
import isMobileDevice from './libs/isMobileDevice'

// Detect the device before loading the page: mobile devices get a lightweight
// glass-ball scene, desktop PCs get the full scroll-driven experience. Lazy
// imports ensure only the relevant bundle is downloaded.
const App = React.lazy(() =>
  isMobileDevice()
    ? import('./scenes/MobileGlassBall/MobileGlassBall')
    : import('./App')
)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <React.Suspense fallback={null}>
      <App />
    </React.Suspense>
  </React.StrictMode>
)


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
